import React from 'react';

function Layout({ children, className }) {
  const classes = ['layout', className].filter(Boolean).join(' ');

  return <div className={classes}>{children}</div>;
}

export default Layout;
